module.exports = __webpack_public_path__ + "static/media/profile.55538cd8.png";